import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import moment from 'moment'

import { planTypeForValue } from '_utils/planType'

import styles from '../styles.css'
import {
  reactTableProps,
  tableProps,
  theadGroupProps,
  theadGroupTrProps,
  theadGroupThProps,
  theadProps,
  theadTrProps,
  theadThProps,
  tBodyProps,
  trGroupProps,
  trProps,
  thProps,
  tdProps,
} from '../styles'

const columns = [
  {
    id: 'fullName',
    Header: 'Name',
    accessor: user => `${user.name.first} ${user.name.last}`,
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    id: 'planType',
    Header: 'Plan Type',
    accessor: user => planTypeForValue(user.planType),
  },
  {
    id: 'createdAt',
    Header: 'Date Created',
    accessor: user => moment(user.createdAt).format('MM/DD/YY'),
  },
  {
    id: 'lastActivityAt',
    Header: 'Last Activity',
    accessor: user =>
      user.lastActivityAt ? moment(user.lastActivityAt).format('MM/DD/YY hh:mm') : 'none',
  },
]

class UserTable extends PureComponent {
  static propTypes = {
    userList: PropTypes.array,
    onRowClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    userList: [],
  }

  state = {
    userList: [],
  }

  componentDidMount() {
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = ({ userList }) => {
    this.setState({ userList })
  }

  getTrProps = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: () => this.props.onRowClick(rowInfo.original._id),
        style: {},
      }
    }
    return {}
  }

  filter = (filter, row, column) => {
    const id = filter.pivotId || filter.id
    if (row[id] !== undefined) {
      // if row is last activity at
      if (id === 'lastActivityAt') {
        const sinceDate = moment(row[id])
        const searchDate = moment(filter.value)
        if (searchDate.year() === 2001) {
          searchDate.year(moment().year())
        }
        if (searchDate._isValid) {
          return sinceDate.isAfter(searchDate)
        }
      }

      return String(row[id])
        .toLowerCase()
        .startsWith(filter.value.toLowerCase())
    }
    return true
  }

  render() {
    const { userList } = this.state

    return (
      <ReactTable
        className={classnames(styles.ReactTable, '-highlight')}
        data={userList}
        columns={columns}
        filterable
        defaultFilterMethod={this.filter}
        getProps={reactTableProps}
        getTableProps={tableProps}
        getTheadGroupProps={theadGroupProps}
        getTheadGroupTrProps={theadGroupTrProps}
        getTheadGroupThProps={theadGroupThProps}
        getTheadProps={theadProps}
        getTheadTrProps={theadTrProps}
        getTheadThProps={theadThProps}
        getTbodyProps={tBodyProps}
        getTrGroupProps={trGroupProps}
        getTrProps={this.getTrProps}
        getThProps={thProps}
        getTdProps={tdProps}
        showPageSizeOptions={false}
        defaultPageSize={20}
      />
    )
  }
}

export default UserTable



// WEBPACK FOOTER //
// ./src/views/admin/components/UserTable.js